<template>
  <div class="cui-surface-editor-text">
    <div :style="textContainerStyle" class="origin-top-left absolute-cover">
      <div :style="textInnerStyle" class="bg-transparent">
        <div
          :id="`element-text-wrapper-${element.id}`"
          class="relative break-words whitespace-pre-wrap"
          ref="textWrapperEl"
          :style="textFormattingStyle"
          v-html="displayText"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
  import {escapeHtml} from '~/utils/sanitizers.js';

  const props = defineProps({
    element: Object,
    surface: Object
  });

  const surfaceEditorStore = useSurfaceEditorStore();
  const googleFonts = useGoogleFonts();

  const textWrapperEl = ref();
  const content = computed(() => props.element.content);

  const textContainerStyle = computed(() => ({
    transform: `scale(${content.value?.scale || 1})`
  }));
  const textInnerStyle = computed(() => ({
    width: `${props.element.width / content.value?.scale}px`,
    height: `${props.element.height / content.value?.scale}px`,
  }));

  const {height: textHeight} = useElementSize(textWrapperEl);

  watch(textHeight, newVal => surfaceEditorStore.morphText({
    element: props.element,
    height: Math.ceil(newVal * content.value.scale)
  }));

  const textFormattingStyle = computed(() => ({
    fontSize: `${content.value.font_size}px`,
    lineHeight: `${content.value.line_height * content.value.font_size}px`,
    letterSpacing: `${content.value.letter_spacing || 0}em`,
    ...googleFonts.parseFontString(content.value.font_family).css,
    textAlign: content.value.align,
    fontWeight: content.value.bold ? 600 : 'normal',
    fontStyle: content.value.italic ? 'italic' : 'normal',
    textDecoration: (content.value.underline || content.value.strikethrough)
      ? `${content.value.underline ? 'underline' : ''} ${content.value.strikethrough ? 'line-through' : ''}`
      : 'none',
    color: content.value.color
  }));

  const displayText = computed(() => {
    // Split by newlines, convert empty lines to <br>, then join as paragraphs
    const lines = content.value.text.split('\n');
    const processedLines = lines.map(line => line.trim() === '' ? '<br>' : escapeHtml(line));
    const paragraphedText = processedLines.join('</p><p>');

    return `<p>${paragraphedText}</p>`;
  });

</script>
